import React from 'react'

function Loading() {
    return (
        <div  className='w-screen h-screen flex justify-center items-center'>
            <div class="custom-loader"></div>
        </div>
    )
}

export default Loading